// Angular
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';

// 3rdparty
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
// Hostware
import { GroupDetailed, GroupMembersFlattened, vwGroupPerformaceDetailed } from '@app/kip/dto/vwPerformance';

import { SpinnerService } from '@app/core/services/spinner.service';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { SubscriberParameterService } from '@app/kip/services/subscriber-parameter.service';
import { PerformanceReportFilterParameter } from '@app/kip/components/detailed-performance-report-filter/detailed-performance-report-filter.component';
import { RequestResult } from '@app/core/dto/RequestResult';
import { MatTableDataSource } from '@angular/material/table';
import { SubscriberParameter } from '@app/kip/dto/SubscriberParameter';
import { PerformanceService } from '@app/kip/services/performance-service';
import { formatNumber } from '@angular/common';
import { style } from '@angular/animations';
import { HokParamsService } from '@app/kip/services/hok-params.service';

@Component({
  selector: 'app-detailed-performance-report',
  templateUrl: './detailed-performance-report.component.html',
  styleUrls: ['./detailed-performance-report.component.scss']
})
@AutoUnsubscribe()
export class DetailedPerformanceReportComponent implements OnInit, OnDestroy {

  @ViewChild(MatSort) sort!: MatSort;

  groups: GroupDetailed[] = [];
  tmpGroups: GroupDetailed[] = [];
  flattenedGroupMembers: GroupMembersFlattened[] = [];

  tableColumns: string[] = ["Name", "StandardTime", "TimeSpent", "NumberOfRooms", "NumberOfPublicAreas", "StandardCost", "TimeCost", "Effectiveness"];
  dataSource: MatTableDataSource<GroupMembersFlattened>;
  CleaningWageCosts: number = 0;
  defaultCurrency: string = "HUF";
 
  constructor(
    private translate: TranslateService,
    private spinnerService: SpinnerService,
    private sessionStorageService: SessionStorageService,
    private susbcriberParameterService: SubscriberParameterService,
    private performanceService: PerformanceService
  ) {  }
  //#region =============== Angular Lifecyle events ============================================================================
  async ngOnInit(): Promise<void> {
    const res = await firstValueFrom(this.susbcriberParameterService.loadByTypeCode(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId(),
      "CLEANING_WAGE_COSTS")) as SubscriberParameter;
    this.CleaningWageCosts = res.Param_Int_Value;

  }
  ngOnDestroy(): void {

  }


  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  
  filterChanged(filter: PerformanceReportFilterParameter) {
    this.spinnerService.setSpinnerVisibility(true)
    this.performanceService.LoadGroupPerformancesDetailed(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId(),
      "C", filter.DateFrom, filter.DateTo).subscribe(result => {
        const res = result as RequestResult
        this.groups = (res.Data as vwGroupPerformaceDetailed).Groups;
        this.flattenedGroupMembers = [];
        // flatten the group members
        this.groups.forEach(group => {
          this.flattenedGroupMembers.push({
            IsGroup: true,
            Name: group.GroupName,
            Effectiveness: group.Effectiveness,
            StandardTime: group.StandardTime,
            TimeSpent: group.TimeSpent,
            NumberOfRooms: group.NumberOfRooms,
            NumberOfPublicAreas: group.NumberOfPublicAreas,
            StandardCost: group.StandardCost,
            TimeCost: group.TimeCost
            
          });
          group.Members.forEach(member => {
            this.flattenedGroupMembers.push({
              IsGroup: false,
              Name: member.PersonName,
              Effectiveness: member.Effectiveness,
              StandardTime: member.StandardTime,
              TimeSpent: member.TimeSpent,
              NumberOfRooms: member.NumberOfRooms,
              NumberOfPublicAreas: member.NumberOfPublicAreas,
              StandardCost: member.StandardCost,
              TimeCost: member.TimeCost
              
            });
          });
        })
        this.dataSource = new MatTableDataSource(this.flattenedGroupMembers);
        this.dataSource.sort = this.sort;
         this.spinnerService.setSpinnerVisibility(false)
      })

  }
  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================
  sortData(sortState: Sort) {

  }

  amount(amount: number): string {
    const locale = this.defaultCurrency == "HUF" ? "hu-HU" : "en-US";
    if (this.defaultCurrency == "HUF") {
      return formatNumber(amount, locale, "0.0-0").replace(",", " ");
    } else {
      return formatNumber(amount, locale, "0.0-2").replace(".", ",");
    }
  }
  performanceClass(percent: number) {
    if (percent >= 0 && percent <= 33) {
      return {
        'red-performance': true
      }
    }
    if (percent > 33 && percent <= 66) {
      return {
        'yellow-performance': true
      }
    }
    if (percent >= 66 && percent <= 100000000) {
      return {
        'green-performance': true
      }
    }
  }

  nameColorStyle(item: GroupMembersFlattened) {
    let styles = {};
    styles["padding-top"] = "5px";
    styles["padding-bottom"] = "5px";
    if (item.Effectiveness >= 0 && item.Effectiveness <= 33) {
      styles["background-color"] = "#f35870";
      styles["color"] = "white";
      
    }
    if (item.Effectiveness > 33 && item.Effectiveness <= 66) {
      styles["background-color"] = "#fffc39";
    }
    if (item.Effectiveness >= 66 && item.Effectiveness <= 100000000) {
      styles["background-color"] = "#7ec681";
      styles["color"] = "white";
    }
    if (item.IsGroup) {
      styles["font-weight"] = "500";
      styles["margin-left"] = "30px !important";
      styles["border-bottom"]="2px solid #101a11";
      // styles["border-radius"]="8px";


    }
    return styles;

  }

  groupStyle(item: GroupMembersFlattened) {
    let styles = {};
    if( !item.IsGroup) {
      styles["margin-left"]="20px";
      
    }
    return styles;
  }

  groupHeaderStyle(item: GroupMembersFlattened) {
    let styles = {};
    if( item.IsGroup) {
      styles["background-color"]="#ede9e9";
      styles["border-bottom"]="2px solid #101a11";
      styles["font-weight"]="500";
    }
    return styles;
  }





  //#endregion =================================================================================================================
}

//LoadGroupPerformancesDetailed
